import React from "react";
import { Modal } from "react-bootstrap";
import "../../../Styles/components/modal.scss";

export default function AutoPayConfirmationModal({
  isOpen,
  message,
  onClose,
  onConfirm,
  title,
}) {
  return (
    <Modal
      centered
      show={isOpen}
      onHide={onClose}
      dialogClassName="validation-popup-modal"
    >
      <Modal.Body className="validation-popup">
        <button
          type="button"
          className="validation-popup__close"
          onClick={onClose}
          aria-label="Close popup"
        >
          &times;
        </button>

        <div className="validation-popup__header">
          <div className="validation-popup__icon-shell">
            <img src="/Images/caution.png" alt="Confirmation" />
          </div>
          <h3 className="validation-popup__title">{title}</h3>
        </div>

        <div className="validation-popup__message">{message}</div>

        <div className="validation-popup__button-row">
          <button
            type="button"
            className="validation-popup__button validation-popup__button--secondary"
            onClick={onClose}
          >
            No
          </button>
          <button
            type="button"
            className="validation-popup__button validation-popup__button--primary"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
